import React, {Component} from 'react';
import {number, string } from 'prop-types';

export default class Quality extends Component {
    render(){
        const {color, size} = this.props;
        return (
          <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1000 1000" enableBackground="new 0 0 1000 1000" xmlSpace="preserve">
            <g>
              <path fill={color} d="M366.8,910.7h400.6c35.6,0,87.8-59.8,155.1-195.3C970.8,618.1,990,535,990,535v-83.5c0-45.9-48.4-80.8-97.4-80.8H598.4l62.7-185.4c8.7-25.7,1-54.1-19.4-72l-16.4-14.4c-15.4-13.1-38.2-12.6-53,1.2L304.5,351.3c-17.8,16.7-49.3,47.7-49.3,111.1v349.5C255.2,857.9,317.8,910.7,366.8,910.7 M10,419.7h196.1v491H10V419.7z"/>
            </g>
          </svg>
        )
    }
}

Quality.propTypes = {
    color: string,
    size: number
};


Quality.defaultProps = {
    color: '#fff',
    size:25
};